"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointerDiv = exports.ReportCardDescription = exports.StyledLink = exports.ReportCardTitle = void 0;
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importDefault(require("styled-components"));
exports.ReportCardTitle = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.brand1};
	font-size: 1.2rem;
	font-weight: bold;
`;
exports.StyledLink = (0, styled_components_1.default)(elements_1.Link) `
	transition: all 0.2s ease;
	&:hover {
		background-color: ${({ theme }) => theme.color.gray4};
	}
`;
exports.ReportCardDescription = styled_components_1.default.div `
	font-size: 1rem;
	color: ${({ theme }) => theme.color.black};
`;
exports.PointerDiv = styled_components_1.default.div `
	width: 100%;
	height: 100%;
	cursor: pointer;
`;
